import { createSelector, createSlice } from '@reduxjs/toolkit';
import { WebsiteState } from '../store';
import { Json } from '@gift/types/Json';

export const { actions, reducer } = createSlice({
    name: 'scene',
    initialState: {
        id: '-1',
        pluginId: 'none',
        options: {}
    } as Json.Scene<any>,
    reducers: {}
});

export const createOptionBindings = <TOptions>() => ({
    createOptionSelector: <T>(selector: (options: TOptions) => T) => createSelector(
        (state: WebsiteState) => state.scene.options as TOptions,
        o => selector(o))
});